import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseCrudService } from '@gipi-shared/services/base-crud.service';
import { CustomAuthenticationService } from '@gipi-shared/services/custom-authentication.service';
import { FinancialPaths } from '../../../paths/financial.paths';
import { BaseFilterDTO } from '../../../shared/models/dto/base-filter.dto';
import { FinancialFlagCard } from '../models/flag-card.model';

@Injectable({ providedIn: 'root' })
export class FinancialFlagCardService extends BaseCrudService<FinancialFlagCard, BaseFilterDTO> {

    constructor(
        http: HttpClient,
        authenticationService: CustomAuthenticationService
    ) {
        super(FinancialPaths.flagCard, http, authenticationService);
    }

}
